import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useProjectAccessCtx } from './ProjectAccessContext';
import { hasPerm } from './hooks/useProjectAccess';

export default function RequireProjectPermission({
    perm,
    children,
    fallback = 'wbs',
}: {
    perm: string;
    children: JSX.Element;
    fallback?: string;
}) {
    const { projectId } = useParams();
    const { access, isLoading } = useProjectAccessCtx();

    if (isLoading) return <div className="p-4 text-sm text-gray-500">권한 확인 중…</div>;

    if (!hasPerm(access?.permissions, perm)) {
        return <Navigate to={`/projects/${projectId}/${fallback}`} replace />;
    }

    return children;
}
